var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 12.5088C4.425 12.5088 3.7575 13.1838 3.7575 14.0088C3.7575 14.8338 4.425 15.5088 5.25 15.5088C6.075 15.5088 6.75 14.8338 6.75 14.0088C6.75 13.1838 6.075 12.5088 5.25 12.5088ZM0.75 0.508789V2.00879H2.25L4.95 7.70129L3.9375 9.53879C3.8175 9.74879 3.75 9.99629 3.75 10.2588C3.75 11.0838 4.425 11.7588 5.25 11.7588H14.25V10.2588H5.565C5.46 10.2588 5.3775 10.1763 5.3775 10.0713L5.4 9.98129L6.075 8.75879H11.6625C12.225 8.75879 12.72 8.45129 12.975 7.98629L15.66 3.11879C15.72 3.01379 15.75 2.88629 15.75 2.75879C15.75 2.34629 15.4125 2.00879 15 2.00879H3.9075L3.2025 0.508789H0.75ZM12.75 12.5088C11.925 12.5088 11.2575 13.1838 11.2575 14.0088C11.2575 14.8338 11.925 15.5088 12.75 15.5088C13.575 15.5088 14.25 14.8338 14.25 14.0088C14.25 13.1838 13.575 12.5088 12.75 12.5088Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.20a63cc628ff16caabc8497241c4c1b4.svg";
export { ForwardRef as ReactComponent };